import React from "react";
import { useFamilyData } from "../../hooks/useFamilyData";

export default function HistoryCard({ familyId, isPro }) {
  const { history = [] } = useFamilyData(familyId);

  // 🔒 PRO FEATURE: Unlimited History
  // Free users only see the last 5 events
  const displayHistory = isPro ? history : history.slice(0, 5);

  return (
    <div className="glass parent-card">
      <div className="card-header">
        <h2>History</h2>
        {!isPro && history.length > 5 && (
            <small style={{ opacity: 0.6, fontSize: '0.75rem' }}>Pro for full history</small>
        )}
      </div>

      <div className="card-body">
        {displayHistory.length === 0 && (
          <div style={{ display: "grid", gap: 8 }}>
            <small>No recent activity yet.</small>
            <button
              className="btn-nav"
              type="button"
              onClick={() =>
                document.querySelector("[data-tour='parent-task-card']")?.scrollIntoView({ behavior: "smooth", block: "center" })
              }
            >
              Create first chore
            </button>
          </div>
        )}

        {displayHistory.map(h => (
          <div key={h.id} className="card">
            <strong>{h.kidName || "System"}</strong>{" "}
            {h.type}{" "}
            <em>{h.title}</em>
          </div>
        ))}
      </div>
    </div>
  );
}
